Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initialState = void 0;
exports.initialState = {
  inPreviewMode: false,
  isFetching: false
};